import { gql } from '@apollo/client';

// Fragments
export const CONFIGURATION_FRAGMENT = gql`
  fragment ConfigurationFragment on Configuration {
    _id
    key
    value
    description
    dataType
    createdAt
    updatedAt
  }
`;

// Queries
export const GET_CONFIGURATIONS = gql`
  ${CONFIGURATION_FRAGMENT}
  query GetConfigurations(
    $filter: ConfigurationFilterInput
    $page: Int = 1
    $pageSize: Int = 10
  ) {
    configurations(filter: $filter, page: $page, pageSize: $pageSize) {
      edges {
        ...ConfigurationFragment
      }
      totalCount
    }
  }
`;

export const GET_CONFIGURATION = gql`
  ${CONFIGURATION_FRAGMENT}
  query GetConfiguration($key: String!) {
    configuration(key: $key) {
      ...ConfigurationFragment
    }
  }
`;

export const GET_CONFIGURATIONS_BY_CATEGORY = gql`
  ${CONFIGURATION_FRAGMENT}
  query GetConfigurationsByCategory($category: String!) {
    configurationsByCategory(category: $category) {
      ...ConfigurationFragment
    }
  }
`;

// Mutations
export const CREATE_CONFIGURATION = gql`
  ${CONFIGURATION_FRAGMENT}
  mutation CreateConfiguration($input: ConfigurationInput!) {
    createConfiguration(input: $input) {
      ...ConfigurationFragment
    }
  }
`;

export const UPDATE_CONFIGURATION = gql`
  ${CONFIGURATION_FRAGMENT}
  mutation UpdateConfiguration(
    $key: String!
    $input: UpdateConfigurationInput!
  ) {
    updateConfiguration(key: $key, input: $input) {
      ...ConfigurationFragment
    }
  }
`;

export const DELETE_CONFIGURATION = gql`
  mutation DeleteConfiguration($key: String!) {
    deleteConfiguration(key: $key)
  }
`;

export const CREATE_DEFAULT_CONFIGURATIONS = gql`
  ${CONFIGURATION_FRAGMENT}
  mutation CreateDefaultConfigurations {
    createDefaultConfigurations {
      ...ConfigurationFragment
    }
  }
`;

export const RESET_CONFIGURATION_TO_DEFAULT = gql`
  ${CONFIGURATION_FRAGMENT}
  mutation ResetConfigurationToDefault($key: String!) {
    resetConfigurationToDefault(key: $key) {
      ...ConfigurationFragment
    }
  }
`;

// Compliance thresholds: dedicated query + mutation backed by purpose-built
// resolvers. Kept separate from the generic Configuration CRUD ops so that
// the SystemAdmin UI can present a structured form and so that read/write
// can both flow through the validated, defaults-aware code paths in
// node/src/graphql/metrics/threshold-config(-types).ts.
export const COMPLIANCE_THRESHOLDS_FRAGMENT = gql`
  fragment ComplianceThresholdsFragment on ComplianceThresholds {
    thresholdNotCompliant
    thresholdPartialCompliant
    thresholdFullyCompliant
    thresholdHighRisk
    thresholdMediumRisk
    thresholdLowRisk
  }
`;

export const GET_COMPLIANCE_THRESHOLDS = gql`
  ${COMPLIANCE_THRESHOLDS_FRAGMENT}
  query GetComplianceThresholds {
    complianceThresholds {
      ...ComplianceThresholdsFragment
    }
  }
`;

export const UPDATE_COMPLIANCE_THRESHOLDS = gql`
  ${COMPLIANCE_THRESHOLDS_FRAGMENT}
  mutation UpdateComplianceThresholds($input: ComplianceThresholdsInput!) {
    updateComplianceThresholds(input: $input) {
      ...ComplianceThresholdsFragment
    }
  }
`;
